import React from 'react';

import HTMLContent from './htmlContent';

export default function NeoText({ config }) {
	return <HTMLContent content={config['text'] || ""}/>;
}
